export const REF_NAME = 'PORTGROUP';
export const REF_PATH = 'portgroup';
export const NAME = 'Port group';
